// @flow

import React, { type Node } from 'react';
import { getCustomerEmail, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import styled from 'styled-components';

export function MailWarning(): Node {
  const incomingPayment = useIncomingPayment();
  return (
    <Root data-cy-id="boleto-success-email-sent-message">
      Seu boleto foi enviado para o email <strong>{getCustomerEmail(incomingPayment)}</strong>. <br/>
      Copie os números para pagar seu boleto.
    </Root>
  );
}

const Root = styled.div`
  text-align: left;
  color: ${props => props.theme.colors.black};
  margin: 16px 0;
`;
